import React from 'react'
import MaterialSymbol from '../material-symbol'

const ReportProblem = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="report_problem" {...props} />
))

ReportProblem.displayName = 'ReportProblem'

export default ReportProblem
